import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useRecalculateDrugQuote = () => {
    const { mutate: recalculateDrugQuote, isLoading } = useMutation(
        async (id) => {
            const response = await SrxApi.post(`/drugsearch/recalculatequote/${id}`);
            return response?.data;
        },
        {
            onSuccess: (data) => {
                const message =
                    data?.message ?? data?.data?.message ?? 'Drug quote recalculated successfully!';
                toast.success(message);
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message ||
                    error?.message ||
                    'Failed to recalculate drug quote';
                toast.error(errorMessage);
            },
        }
    );

    return {
        recalculateDrugQuote,
        isRecalculateDrugQuoteLoading: isLoading,
    };
};

export default useRecalculateDrugQuote;
